import { faFileExport } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack } from "@mui/joy";
import { memo, useCallback } from "react";
import { ExportAudienceButton } from "features/mediaDataRoom/components/MediaDataRoomAudiencesTable/components";
import {
  useAdvertiserAudiences,
  useMediaDataRoom,
} from "features/mediaDataRoom/contexts";
import {
  type AudienceAb,
  MediaDataRoomVersion,
} from "features/mediaDataRoom/models";

interface AudienceAbDrawerActionsProps {
  audience: AudienceAb;
}

const AudienceAbDrawerActions = memo<AudienceAbDrawerActionsProps>(
  ({ audience }) => {
    const { isPublishingAudience, publishAudience } = useAdvertiserAudiences(
      MediaDataRoomVersion.ab
    );
    const {
      supportedFeatures: { canShareAudience, canExportAudience },
    } = useMediaDataRoom(MediaDataRoomVersion.ab);
    const handlePublishAudience = useCallback(
      () => audience && publishAudience(audience.id),
      [audience, publishAudience]
    );
    return (
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        {canExportAudience && (
          <ExportAudienceButton audience={audience} menuPlacement="top" />
        )}
        {canShareAudience &&
        (audience.status !== "published" ||
          audience.isPublishedAsIntermediate) ? (
          <Button
            color="primary"
            loading={isPublishingAudience}
            onClick={handlePublishAudience}
            startDecorator={
              <FontAwesomeIcon fixedWidth={true} icon={faFileExport} />
            }
            variant="solid"
          >
            Grant publisher access
          </Button>
        ) : null}
      </Stack>
    );
  }
);

AudienceAbDrawerActions.displayName = "AudienceAbDrawerActions";

export default AudienceAbDrawerActions;
